<template>
  <div class="sn-f-b-c app-logo">
    <div class="sn-f-s-c sn-f-1 logo">
      <img class="main" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/logo/' + $sn.utils.getHospitalId() + '.png'">
      <img class="sub" v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDQL"
      :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/logo/' + $sn.utils.getHospitalId() + '-header.png'">
    </div>
    <div class="sn-f-c-c qr" v-if="qrCaption && qrCaption.length > 0">
      <div class="sn-f-col-c-c sn-pointer qr-single" :key="i" v-for="(title, i) in qrCaption">
        <div class="sn-f-c-c direct">
          <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/qr/' + i + '-0-' + $sn.utils.getHospitalId() + '.png'">
        </div>
        <div class="title" v-html="title"></div>
        <div class="expand">
          <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/qr/' + i + '-1-' + $sn.utils.getHospitalId() + '.png'">
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';

export default {
  name: 'app-logo',
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      perpetual: Constants,
      qrCaption: self.$sn.getConfig('qrCaption')
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.eventBus.$on('Broadcast_InitialComplete', () => {
        this.qrCaption = this.$sn.getConfig('qrCaption');
      });
    });
  },
  beforeDestroy() {
    window.eventBus.$off('Broadcast_InitialComplete');
  }
};
</script>
<style lang="scss" scoped>
.app-logo {
  width: 1280px;
  height: 120px;
  background-color: $white;

  .logo {
    img {
      margin-right: 20px;
    }

    .main {
      width: auto;
      height: 90px;
    }

    .sub {
      width: 500px;
      height: auto;
    }
  }

  .qr {
    margin-right: 20px;

    .qr-single {
      margin-right: 10px;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        .expand {
          display: block;
        }
      }

      .direct {
        overflow: hidden;
        width: 60px;
        height: 60px;
        margin: 5px 0;

        img {
          width: 60px;
          height: auto;
        }
      }

      .title {
        @include fs(16);

        overflow: hidden;
        width: 100%;
        height: 40px;
        color: $text3;
        text-align: center;
      }

      .expand {
        display: none;
        overflow: hidden;
        width: 300px;
        background-color: $main;
        border-radius: 10px;
        padding: 10px;
        position: absolute;
        top: 115px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;

        img {
          width: 280px;
          height: auto;
        }
      }
    }
  }
}
</style>
